import FlintButton from "../../../controls/FlintButton";
import React, {MouseEventHandler} from "react";
import PageTitleComponent from "./PageTitleComponent";
import {ThemeColorClasses} from "@progress/kendo-react-common";
import {ThemeColoursType} from "../../../../utils/AppConstants";

export default function PageTitleHeaderComponent(props: PageTitleHeaderComponentProps) {
    return (
        
        <div className={"page-title-header d-flex justify-content-between align-items-center mb-md-3 mb-2"}>
            <PageTitleComponent title={props.pageTitle} backUrl={props.backUrl} />
            {props.addNewButton ?
                <FlintButton onClick={props.addNewButton?.onClick}
                             themeColor={props.addNewButton.themeColour}>{props.addNewButton.text}</FlintButton> : null}
        </div>
    )
}

export interface PageTitleHeaderComponentProps {
    pageTitle: string;
    backUrl?: string | null | undefined;
    /** optional add new item BUTTON */
    addNewButton?: {
        text: string, onClick: MouseEventHandler,
        themeColour?: ThemeColoursType
    }
}